/* Padel offer code: copy-to-clipboard for [data-po-copy] buttons (cards, product page, cart upsell).
   One delegated listener, guarded so repeated script tags, AJAX grid swaps and Theme Editor reloads never add a second.
   Never applies the code. Feedback: the button shows "Copied" for 2s; one shared polite live region announces it. */
(function () {
  if (window.__poOfferCode) return;
  window.__poOfferCode = true;
  var live = null;
  function announce(text) {
    if (!live) {
      live = document.createElement('p');
      live.className = 'sr-only';
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('data-po-copy-live', '');
      live.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;';
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 30);
  }
  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text; ta.setAttribute('readonly', ''); ta.style.cssText = 'position:fixed;top:-1000px;opacity:0;';
    document.body.appendChild(ta); ta.select();
    var ok = false; try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(ta);
    return ok;
  }
  function done(btn, ok) {
    btn.classList.toggle('is-copied', ok);
    announce(ok ? btn.getAttribute('data-done') : btn.getAttribute('data-fail'));
    clearTimeout(btn.__poT);
    btn.__poT = setTimeout(function () { btn.classList.remove('is-copied'); }, 2000);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-po-copy]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var code = btn.getAttribute('data-po-copy') || '';
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(function () { done(btn, true); }, function () { done(btn, fallbackCopy(code)); });
    } else {
      done(btn, fallbackCopy(code));
    }
  }, true);
  // Best Price in the product block (snippets/discount-code-block) follows the selected variant; an unavailable variant
  // hides it. Quick View inserts its HTML without running inline scripts, so the binding lives here: one listener per
  // section id (the theme's maximize:variant-picker:updated:<id> event), resolving the live blocks on every event.
  var sids = {};
  function apply(sid, v) {
    document.querySelectorAll('[data-dcb-block][data-dcb-sid="' + sid + '"]').forEach(function (el) {
      if (!el.querySelector('[data-dcb-best-map]')) return; // not a Padel Best Price block: never touched
      var map = el.__poMap; if (!map) { try { map = el.__poMap = JSON.parse((el.querySelector('[data-dcb-best-map]') || {}).textContent || '{}'); } catch (e) { map = el.__poMap = {}; } }
      var val = v && map[String(v.id)], out = el.querySelector('[data-dcb-best]');
      el.style.display = val ? '' : 'none'; if (val && out) out.innerHTML = val; // trusted: the theme's own po-money markup from Liquid JSON
    });
  }
  function bind(root) {
    (root.querySelectorAll ? root.querySelectorAll('[data-dcb-block][data-dcb-sid]') : []).forEach(function (el) {
      var sid = el.getAttribute('data-dcb-sid'); if (!sid || sids[sid]) return; sids[sid] = true;
      document.addEventListener('maximize:variant-picker:updated:' + sid, function (e) { apply(sid, e.detail && e.detail.currentVariant); });
    });
  }
  window.poDcbBind = function () { bind(document); };
  bind(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(document); });
  new MutationObserver(function (ms) { for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) { var n = ms[i].addedNodes[j]; if (n.nodeType === 1 && (n.matches('[data-dcb-block]') || n.querySelector('[data-dcb-block]'))) { bind(n.matches('[data-dcb-block]') ? n.parentNode : n); } } }).observe(document.documentElement, { childList: true, subtree: true });
})();
